function getNameByValue(dataItems, value) {
  const obj = dataItems.find(item => item.value === value)
  if (obj) return obj.name
  return 'N/A'
}

function getValueByName(dataItems, name) {
  const obj = dataItems.find(item => item.name === name)
  if (obj) return obj.value
  return 'N/A'
}

export { getNameByValue, getValueByName }
